import { AuthorizeGuard } from './authorize.guard';
import { NotAuthorizeGuard } from './not-authorize.guard';
import { PermissionGuard } from './permission.guard';
import { MandatoryPasswordChangeGuard } from './mandatory-password-change.guard';
import { FeatureGuard } from './feature.guard';
import { SuggestionCommitteeAccessGuard } from './suggestion-committee-access.guard';
import { ProjectAccessGuard } from './project-access.guard';

export const guardProviders = [
    AuthorizeGuard,
    NotAuthorizeGuard,
    PermissionGuard,
    MandatoryPasswordChangeGuard,
    FeatureGuard,
    SuggestionCommitteeAccessGuard,
    ProjectAccessGuard,
];
